export default __webpack_public_path__ + "static/media/bang-sound.116944f6.jpeg";